import { registerCondition } from '../conditionRegisterer';
export var CONDITION_NAME = 'false';
export function condition() {
  return false;
}
registerCondition(CONDITION_NAME, condition, {
  name: 'False'
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/handsontable/es/plugins/filters/condition/false.js
// module id = 953
// module chunks = 0